import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { API_URL } from '@constants';
import { AcceptedResourceItemType } from '@shared/components/resource-item/types';

@Service()
export class BookmarksService {
  http = inject(HttpClient);

  getBookmarks = () =>
    this.http.get<AcceptedResourceItemType[]>(`${API_URL}/bookmarks`);

  deleteBookmark = (rid: number) =>
    this.http.delete(`${API_URL}/bookmarks/${rid}`);

  addBookmark = (rid: number) =>
    this.http.put(`${API_URL}/bookmarks/${rid}`, null);

  toggleBookmark = (rid: number, isBookmarked: boolean) =>
    this.http.request(
      isBookmarked ? 'delete' : 'put',
      `${API_URL}/bookmarks/${rid}`
    );
}
